import { Component } from '@angular/core';
import { Storage } from '@ionic/storage-angular';
import { Platform } from '@ionic/angular';
import { register } from 'swiper/element/bundle';

register();

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  constructor(
    private storage: Storage,
    private platform: Platform,
  ) {
    this.initializeApp();
  }
  async ngOnInit() {
    // If using a custom driver:
    // await this.storage.defineDriver(MyCustomDriver)
    await this.storage.create();
  }

  initializeApp() {
    this.platform.ready().then(() => {

      this.platform.backButton.subscribe(() => {
        if (window.location.pathname == "/success-form" || window.location.pathname == "/welcome") {
            navigator['app'].exitApp();
        }else{
          //do nothing
        }
      });
    });
  }
}
